import { StyleSheet, Dimensions } from 'react-native'
import { Fonts, Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

const SCREEN_WIDTH = Dimensions.get('window').width

const styles = StyleSheet.create({
  scrollView: {
    paddingTop: 30,
    paddingHorizontal: 16,
    paddingBottom: 20,
  },
  bannerTitle: {
    fontSize: Fonts.size.input
  },
  bannerDescription: { fontSize: Fonts.size.regularSmall + 0.5 },
  bannerButtonStyle: theme => ({
    backgroundColor: theme.colors.cardBackgroundColorFour
  }),
  bannerButtonTitleStyle: theme => ({
    color: theme.colors.textColor
  }),
  boldTitle: theme => ({
    fontSize: Fonts.size.h4,
    ...Fonts.type.bold,
    // paddingHorizontal: 20,
    color: theme.colors.textColor,
    marginTop: 36,
    marginBottom: 16
  }),
  selectionListContainer: {
    height: 'auto',
    width: 'auto',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignContent: 'center'
  },
  selectionListItem: theme => ({
    backgroundColor: theme.colors.cardBackgroundColorFour,
    borderColor: 'transparent',
    width: SCREEN_WIDTH / 2 - 16,
    height: 60,
    borderWidth: 2
  }),
  selectionListActiveItem: {
    borderColor: '#007C92',
    height: 60,
    width: SCREEN_WIDTH / 2 - 16,
    borderWidth: 2,
    flexGrow: 1
  },
  graySubtitle: theme => ({
    fontSize: Fonts.size.regularSmall,
    lineHeight: 20,
    // paddingHorizontal: 20,
    color: theme.colors.textColor,
    marginBottom: 16
  }),
  searchButton: {
    marginTop: 30,
    marginBottom: 16
  },
  image: {
    zIndex: 5,
    width: SCREEN_WIDTH - 32,
    height: 'auto',
    margin: 16
  },
  cardTitle: {
    color: Colors.white,
    // fontSize: Fonts.size.regular,
    fontSize: Fonts.size.input,
    lineHeight: 24
    // marginBottom: 20,
  },
  cardDescription: {
    color: Colors.white,
    // fontSize: Fonts.regularSmall,
    fontSize: Fonts.size.regularSmall
  },
  offerContainer: { marginTop: 20 },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 16
  },
  marginHorizontal0: {
    marginHorizontal: 0
  },
})

export default styles
